<div class="page-container">
    <div class="card" [appDynamicHeight]="24">
        <form [formGroup]="enquiryForm" class="form-case">
            <!-- Section: Client Info -->
            <div class="form-section">
                <div class="form-section-title">
                    Client Information
                    <div class="section-description">
                        Provide the client's basic information.
                    </div>
                </div>
                <div class="form-grid">
                    <div class="form-group">
                        <label for="client_first_name">First Name</label>
                        <input type="text" id="client_first_name" formControlName="client_first_name" placeholder="John">
                        @if (getErrorMessage('client_first_name', 'First Name')) {
                            <div class="error-msg">
                                {{ getErrorMessage('client_first_name', 'First Name') }}
                            </div>
                        }
                    </div>
                    <div class="form-group">
                        <label for="client_last_name">Last Name</label>
                        <input type="text" id="client_last_name" formControlName="client_last_name" placeholder="Doe">
                        @if (getErrorMessage('client_last_name', 'Last Name')) {
                            <div class="error-msg">
                                {{ getErrorMessage('client_last_name', 'Last Name') }}
                            </div>
                        }
                    </div>
                </div>
            </div>

            <!-- Section: Case Information -->
            <div class="form-section">
                <div class="form-section-title">
                    Case Information
                    <div class="section-description">
                        Provide the case's basic information.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="form-grid">
                        <div class="form-group">
                            <label for="injury_type">Basic Injury Type</label>
                            <app-select 
                                formControlName="injury_type" 
                                [options]="injuryTypeOptions"
                                placeholder="Select type..." 
                                [searchable]="false">
                            </app-select>
                            @if (getErrorMessage('injury_type', 'Injury Type')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('injury_type', 'Injury Type') }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label for="date_of_incident">Date of Incident</label>
                            <app-date-picker formControlName="date_of_incident" placeholder="Select date" [maxDate]="today"></app-date-picker>
                            @if (getErrorMessage('date_of_incident', 'Date of Incident')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('date_of_incident', 'Date of Incident') }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label for="lien_amount">Lien Amount ($)</label>
                            <input appAmountFormat id="lien_amount" formControlName="lien_amount" placeholder="0.00">
                            @if (getErrorMessage('lien_amount', 'Lien Amount')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('lien_amount', 'Lien Amount') }}
                                </div>
                            }
                        </div>
                    </div>
                    <div class="form-group full-width">
                        <label for="lien_details">Additional details of lien issue / status (Optional)</label>
                        <textarea id="lien_details" formControlName="lien_details" rows="3" placeholder="Provide any additional context regarding the lien..."></textarea>
                    </div>
                    <div class="form-grid">
                        <div class="form-group">
                            <label for="settlement_status">Settlement Status</label>
                            <app-select 
                                formControlName="settlement_status" 
                                [options]="settlementStatusOptions"
                                placeholder="Select status..."
                                [searchable]="false"
                                >
                            </app-select>
                            @if (getErrorMessage('settlement_status', 'Settlement Status')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('settlement_status', 'Settlement Status') }}
                                </div>
                            }
                        </div>
                        @if (enquiryForm.get('settlement_status')?.value === 'SETTLED') {
                            <div class="form-group">
                                <label for="settlement_amount">Settlement Amount ($)</label>
                                <input appAmountFormat id="settlement_amount" formControlName="settlement_amount" placeholder="0.00">
                                @if (getErrorMessage('settlement_amount', 'Settlement Amount')) {
                                    <div class="error-msg">
                                        {{ getErrorMessage('settlement_amount', 'Settlement Amount') }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    <div class="form-grid">
                        <div class="form-group">
                            <label>Settlement Loans</label>
                            <div class="radio-group">
                                <label class="radio-option">
                                    <input type="radio" formControlName="settlement_loans" [value]="true">
                                    <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio-option">
                                    <input type="radio" formControlName="settlement_loans" [value]="false">
                                    <span class="radio-label">No</span>
                                </label>
                            </div>
                        </div>
                        @if (enquiryForm.get('settlement_loans')?.value) {
                            <div class="form-group">
                                <label for="loan_amount">Amount of Loan ($)</label>
                                <input appAmountFormat id="loan_amount" formControlName="loan_amount" placeholder="0.00">
                                @if (getErrorMessage('loan_amount', 'Loan Amount')) {
                                    <div class="error-msg">
                                        {{ getErrorMessage('loan_amount', 'Amount of Loan') }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>

            <!-- Section: Financial Details -->
            <div class="form-section">
                <div class="form-section-title">
                    Financial Details
                    <div class="section-description">
                        Provide the case's financial details.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="form-group">
                        <label for="total_medicals">Total Medicals INCLUDING hospital lien at issue ($)</label>
                        <input appAmountFormat id="total_medicals" formControlName="total_medicals" placeholder="0.00">
                        @if (getErrorMessage('total_medicals', 'Total Medicals')) {
                            <div class="error-msg">
                                {{ getErrorMessage('total_medicals', 'Total Medicals') }}
                            </div>
                        }
                    </div>
                    <div class="form-grid">
                        <div class="form-group">
                            <label for="legal_fees">Legal Fees ($)</label>
                            <input appAmountFormat id="legal_fees" formControlName="legal_fees" placeholder="0.00">
                            @if (getErrorMessage('legal_fees', 'Legal Fees')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('legal_fees', 'Legal Fees') }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label for="costs">Costs ($)</label>
                            <input appAmountFormat id="costs" formControlName="costs" placeholder="0.00">
                            @if (getErrorMessage('costs', 'Costs')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('costs', 'Costs') }}
                                </div>
                            }
                        </div>
                    </div>
                    <div class="form-actions align-left">
                        <button type="button" class="btn btn-md btn-primary" (click)="handleSave()">Submit</button>
                        <button type="button" class="btn btn-md btn-default" (click)="handleCancel()">Cancel</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>